export default function SectionHeadingStatic({ value }: { value: string }) {
  return (
    <div className="rating-header avoid-page-break-inside">
      <p className="rating-name" data-cy="template-section-heading">
        {value}
      </p>
    </div>
  );
}
